// extracted by mini-css-extract-plugin
export default {"buy-online-url-modal":"buy-online-url-modal","online-url-modal-body":"online-url-modal-body","input-container":"input-container","url-field":"url-field"};